import { render } from "./KeseluruhanKodingMengikutDaerah.vue?vue&type=template&id=5a83419f"
import script from "./KeseluruhanKodingMengikutDaerah.vue?vue&type=script&lang=js"
export * from "./KeseluruhanKodingMengikutDaerah.vue?vue&type=script&lang=js"

import "./KeseluruhanKodingMengikutDaerah.vue?vue&type=style&index=0&id=5a83419f&lang=css"
import "./KeseluruhanKodingMengikutDaerah.vue?vue&type=style&index=1&id=5a83419f&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__